// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/progress.css'
import { Progress } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'

function QuestProgress ({ location }: { location: any }) {
  let val = 1

  if (location.pathname.startsWith('/artikel')) {
    val = 3
  } else if (location.pathname.startsWith('/abstimmungsfragen')) {
    val = 2
  }

  return (
    <Progress
      id='progressbar'
      value={val}
      total={3}
      attached={'top'}
      color={'orange'}
    />
  )
}

export const ProgressSteps = withRouter(QuestProgress)



// WEBPACK FOOTER //
// ./src/components/progressSteps/component.js